import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import BornholmImage from '../components/bornholm.gif'; // Import the Bornholm flag image

function Year2021() {
  const navigate = useNavigate(); // Initialize the navigate function

  // Function to handle container clicks
  const handleContainerClick = (path) => {
    navigate(path); // Navigate to the specified path
  };

  const handleBackClick = () => {
    navigate('/'); // Navigate to the home page
  };

  return (
    <div className="year-page">
      <h1>2021 Photos</h1>
      <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
      <div className="location-grid">
        {/* Bornholm Location */}
        <div
          className="location-container"
          onClick={() => handleContainerClick('/bornholm')} // Redirect to /bornholm
          style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
        >
          <div
            className="image-container"
            style={{ backgroundImage: `url(${BornholmImage})` }} // Set the background image
          ></div>
          <p className="location-name">Bornholm</p>
        </div>
      </div>
    </div>
  );
}

export default Year2021;